import { render, staticRenderFns } from "./accountManage.vue?vue&type=template&id=0f7c760c&scoped=true"
import script from "./accountManage.vue?vue&type=script&lang=js"
export * from "./accountManage.vue?vue&type=script&lang=js"
import style0 from "./accountManage.vue?vue&type=style&index=0&id=0f7c760c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7c760c",
  null
  
)

export default component.exports